import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: "I've tried melatonin, magnesium, L-theanine separately. Why would this be different?",
    answer: "Because none of those address the real problem: your Hyper-Arousal Loop. LyraSleep combines all 5 ingredients in clinical doses to break all 4 parts of the anxiety-sleep cycle. Single ingredients can't do that."
  }, {
    question: 'Will I become dependent like with Ambien?',
    answer: "No. LyraSleep uses natural ingredients that support your body's sleep systems—it doesn't hijack them. You can stop anytime without rebound insomnia."
  }, {
    question: 'Will I wake up groggy?',
    answer: 'No. Unlike melatonin or Ambien, LyraSleep works with your natural sleep cycles. Most users wake up clear and energized.'
  }, {
    question: 'How long does it take to work?',
    answer: 'Most users feel calm within 20 minutes. Sleep improvements often start the first night, with full benefits building over 7-14 days.'
  }, {
    question: 'My anxiety is severe. Will this be strong enough?',
    answer: "LyraSleep is specifically designed for anxiety-induced insomnia—not casual sleep issues. Many users with PTSD, severe anxiety, and 20+ year chronic insomnia report it's the first thing that worked."
  }, {
    question: "What if it doesn't work for me?",
    answer: "30-day money-back guarantee. If you don't sleep better, full refund. We take the risk, not you."
  }];
  return <div className="my-16" data-id="element-225">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-226">
        FAQ: For Chronic Insomniacs Who've Tried Everything
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-227">
        {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200" data-id="element-228">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-229">
              <span className="font-bold text-gray-900 pr-4" data-id="element-230">
                Q: {faq.question}
              </span>
              {openIndex === index ? <ChevronUp className="w-5 h-5 text-purple-600 flex-shrink-0" data-id="element-231" /> : <ChevronDown className="w-5 h-5 text-purple-600 flex-shrink-0" data-id="element-232" />}
            </button>

            {openIndex === index && <div className="px-6 pb-4 text-gray-700 leading-relaxed" data-id="element-233">
                <strong data-id="element-234">A:</strong> {faq.answer}
              </div>}
          </div>)}
      </div>
    </div>;
}